module.exports = __webpack_public_path__ + "img/logo.e8a659b7.png";